//
//
//
//
//
//

export default {
    name: 'ErrorComponent'
}
